<template>
  <section class="files-info" v-if="files.length > 0">
    <h3>Prints</h3>
    <ul>
      <li class="file-row" v-for="file in files" :key="file.fileName">
        <div class="filename">
          <span class="quantity">{{ file.quantity }} x</span>
          <span :title="file.filename">{{ file.fileName }}</span>
        </div>
        <!--  <div class="quantity">
          <span>Aantal: </span><span>{{ file.quantity }}</span>
        </div> -->
        <ul v-if="file.productSpecs.Product || file.productSpecs.product">
          <template
            v-for="(values, specName) in file.productSpecs"
            :key="specName"
          >
            <li v-if="specName !== 'product'">
              <strong>{{ specName }}:</strong>
              {{ Array.isArray(values) ? values.join(', ') : values }}
            </li>
          </template>
        </ul>
        <div class="specs" v-else>
          <span :title="'Formaat:' + file.format">{{ file.format }} </span>

          <span>
            {{ file.colorMode }}
          </span>

          <span :title="file.side">
            {{ file.side }}
          </span>

          <span class="">{{ file.material }}</span>

          <span v-if="file.treatment" :title="file.treatment">
            {{ file.treatment }}
          </span>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  props: ['files']
}
</script>

<style lang="scss" scoped>
h3 {
  font-weight: 600;
}
.file-row {
  //  display: grid;
  //  grid-template-columns: 100px auto;
  //  grid-template-rows: auto auto;
  //  grid-template-areas: 'filename filename' 'quantity specs';
  //  row-gap: 4px;
  padding: 10px 0;
}

.filename {
  // grid-area: filename;
  font-weight: 600;
  padding-bottom: 3px;
}

.quantity {
  // grid-area: quantity;
  padding-right: 10px;

  > span {
    font-weight: 500;
  }
}

.specs {
  //  grid-area: specs;
  //  text-align: right;

  > span {
    padding-left: 10px;

    &:first-child {
      padding-left: 0;
    }
  }
}

:deep(.specs) {
  h4.prod-title {
    font-weight: 500;
    display: inline-block;
    margin-bottom: 5px;
  }

  h4.specs-title {
    font-weight: 500;
    display: inline-block;
    margin-bottom: 0px;
  }

  ul {
    margin-bottom: 7px;
  }
}
</style>
